module.exports = "data:image/gif;base64,R0lGODlhHgAYAMQcAAFejPz+/9Tc5MHR4MvX4rfK3Ze316K92YOq0uPl53Kgz6zE23ql0J6y/42w1Nzh5W+D0Pb9/5Om8/H09Guczejo6Ozs7LOzs6GlqczMzP///4CAgP///wAAAAAAAAAAACH5BAEAABwALAAAAAAeABgAAAWzICeOZGmeaKqWWOu+cAyTWGAHWa7vfBZomgmGFrH1jjygZjiSOZ8tWmVKrVqvVKYIk9h4v+CweJPQcjCPjeWiZq/b8Pf7YcYINkC8Rs/P+/cCdQRjhGMEdQNxbouKcAN1BX17f5J8BXULhWIAnABfC3UHjXKLABIQAG8HdQaVlEAADQ0AeQZ1DpphnZ5eDnUIo4ykcAh1DK6TyZUMdQq5uQp1FNPU1dbX1HVQ2y8r3t/g4CEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/img/calendar-icon.gif
// module id = 1562
// module chunks = 0